


import { chatServiceStart } from '../../api/api';
export default {
name: "PageVisible",
components: {

},
props: {
AppID:String
},
data() {
return {
lastStartTime:0,
};
},
mounted() {
document.addEventListener('visibilitychange', this.handleVisiable)
},
beforeDestroy() {
document.removeEventListener('visibilitychange', this.handleVisiable)
},
methods: {
handleVisiable(e) {
if (e.target.visibilityState === 'visible') {

console.log('visible',Date.now() ,this.AppID)
if(this.AppID && this.AppID.length>0 && Date.now()-this.lastStartTime>=15*60000){ //超过20分钟重新启动服务
chatServiceStart(this.AppID).then(prce=>{
console.log('%c⧭', 'color: #ace2e6', prce)
if(prce.code == 500)
{
chatServiceStart(res.data.app_info.app_id).then(val=>{
console.log('%c⧭', 'color: #ace2e6', val)
})
}
})
}
this.lastStartTime=Date.now()
}
},
},
watch: {

},
};



// WEBPACK FOOTER //
// ./src/myComponents/PageVisible/PageVisible.vue